(function () {
  'use strict';

  /* =============================================
     STATE
     ============================================= */
  const TOTAL_SECTIONS = 4;
  let currentSection = 1;
  const answers = {};

  /* =============================================
     DOM REFS
     ============================================= */
  const sections = document.querySelectorAll('.quiz-section');
  const btnNext = document.getElementById('btnNext');
  const btnBack = document.getElementById('btnBack');
  const btnSeeResults = document.getElementById('btnSeeResults');
  const progressFill = document.getElementById('progressFill');
  const progressText = document.getElementById('progressText');
  const validationMsg = document.getElementById('validationMsg');
  const emailGate = document.getElementById('emailGate');
  /* emailForm, emailInput, emailError — not used when Klaviyo form is active */
  const quizResults = document.getElementById('quizResults');
  const btnRetake = document.getElementById('btnRetake');
  const quizNav = document.querySelector('.quiz-nav');

  /* =============================================
     Q11 EXCLUSIVE OPTION LOGIC
     ============================================= */
  function setupQ11Exclusivity() {
    const q11Checkboxes = document.querySelectorAll('input[name="q11"]');
    q11Checkboxes.forEach(function (cb) {
      cb.addEventListener('change', function () {
        const isExclusive = this.getAttribute('data-exclusive') === 'true';
        if (isExclusive && this.checked) {
          q11Checkboxes.forEach(function (other) {
            if (other !== cb) other.checked = false;
          });
        } else if (!isExclusive && this.checked) {
          q11Checkboxes.forEach(function (other) {
            if (other.getAttribute('data-exclusive') === 'true') other.checked = false;
          });
        }
      });
    });
  }

  /* =============================================
     PROGRESS
     ============================================= */
  function updateProgress() {
    var pct = ((currentSection - 1) / TOTAL_SECTIONS) * 100;
    progressFill.style.width = pct + '%';
    progressText.textContent = 'Section ' + currentSection + ' of ' + TOTAL_SECTIONS;
  }

  /* =============================================
     SHOW / HIDE SECTIONS
     ============================================= */
  function showSection(num) {
    sections.forEach(function (s) {
      s.style.display = 'none';
    });
    var target = document.getElementById('section-' + num);
    if (target) target.style.display = '';

    btnBack.style.display = num > 1 ? '' : 'none';
    if (num === TOTAL_SECTIONS) {
      btnNext.style.display = 'none';
      btnSeeResults.style.display = '';
    } else {
      btnNext.style.display = '';
      btnSeeResults.style.display = 'none';
    }
    validationMsg.style.display = 'none';
    updateProgress();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  /* =============================================
     VALIDATION
     ============================================= */
  function sectionQuestions(sectionNum) {
    var sec = document.getElementById('section-' + sectionNum);
    return sec ? sec.querySelectorAll('.quiz-question') : [];
  }

  function validateSection(sectionNum) {
    var questions = sectionQuestions(sectionNum);
    for (var i = 0; i < questions.length; i++) {
      var q = questions[i];
      var type = q.getAttribute('data-type');
      var name = q.getAttribute('data-question');
      if (type === 'radio') {
        var checked = document.querySelector('input[name="' + name + '"]:checked');
        if (!checked) return false;
      }
      // Checkboxes (q4, q11) are optional — no required validation
    }
    return true;
  }

  /* =============================================
     COLLECT ANSWERS
     ============================================= */
  function collectAnswers() {
    var questions = document.querySelectorAll('.quiz-question');
    questions.forEach(function (q) {
      var name = q.getAttribute('data-question');
      var type = q.getAttribute('data-type');
      if (type === 'radio') {
        var checked = document.querySelector('input[name="' + name + '"]:checked');
        answers[name] = checked ? parseInt(checked.value, 10) : 0;
      } else if (type === 'checkbox') {
        var checked = document.querySelectorAll('input[name="' + name + '"]:checked');
        var vals = [];
        checked.forEach(function (c) { vals.push(parseInt(c.value, 10)); });
        answers[name] = vals;
      }
    });
  }

  /* =============================================
     SCORING
     ============================================= */
  function calculateScore() {
    collectAnswers();
    var total = 0;

    // Radio questions: q1, q2, q3, q5, q6, q7, q8, q9, q10, q12
    ['q1', 'q2', 'q3', 'q5', 'q6', 'q7', 'q8', 'q9', 'q10', 'q12'].forEach(function (key) {
      total += (typeof answers[key] === 'number') ? answers[key] : 0;
    });

    // Q4: multi-select, sum each 1-pt selection but CAP at 4
    if (Array.isArray(answers.q4)) {
      var q4sum = 0;
      answers.q4.forEach(function (v) { q4sum += v; });
      total += Math.min(q4sum, 4);
    }

    // Q11: multi-select, no cap
    if (Array.isArray(answers.q11)) {
      answers.q11.forEach(function (v) { total += v; });
    }

    return total;
  }

  /* =============================================
     TIER LOGIC
     ============================================= */
  function getTier(score) {
    if (score >= 18) {
      return {
        code: 'T1',
        label: 'Tier 1 \u2013 High Awareness Closely Resembles Commonly Reported Mold-Exposure Experiences',
        tag: 'quiz-closely-resembles',
        element: 'resultT1',
        scoreDisplay: 'scoreDisplayT1'
      };
    } else if (score >= 9) {
      return {
        code: 'T2',
        label: 'Tier 2 \u2013 Moderate Awareness Some Similarities to Commonly Reported Mold-Exposure Experiences',
        tag: 'quiz-some-similarities',
        element: 'resultT2',
        scoreDisplay: 'scoreDisplayT2'
      };
    } else {
      return {
        code: 'T3',
        label: 'Tier 3 \u2013 Low Awareness Few Similarities to Commonly Reported Mold-Exposure Experiences',
        tag: 'quiz-few-similarities',
        element: 'resultT3',
        scoreDisplay: 'scoreDisplayT3'
      };
    }
  }

  /* =============================================
     EMAIL VALIDATION
     ============================================= */
  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  /* =============================================
     SHOPIFY CONTACT FORM SUBMISSION (fallback)
     ============================================= */
  function submitToShopifyContact(email, consent, score, tier) {
    var form = document.createElement('form');
    form.method = 'POST';
    form.action = '/contact#contact_form';
    form.style.display = 'none';

    var fields = {
      'form_type': 'contact',
      'utf8': '\u2713',
      'contact[email]': email,
      'contact[body]': [
        'Quiz: Mold Exposure Quiz',
        'Score: ' + score,
        'Tier: ' + tier.code + ' - ' + tier.label,
        'Tag: ' + tier.tag,
        'Consent: ' + (consent ? 'Yes' : 'No'),
        'Timestamp: ' + new Date().toISOString()
      ].join('\n')
    };

    Object.keys(fields).forEach(function (key) {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = key;
      input.value = fields[key];
      form.appendChild(input);
    });

    // We submit via fetch to avoid page reload
    var formData = new FormData(form);
    fetch('/contact#contact_form', {
      method: 'POST',
      body: formData,
      headers: { 'Accept': 'application/json' }
    }).catch(function () {
      // Silent fail — results are already shown; data also in localStorage
    });
  }

  /* =============================================
     DATALAYER PUSH
     ============================================= */
  function pushDataLayer(email, score, tier) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'mold_quiz_completed',
      email: email,
      quiz_name: 'Mold Exposure Quiz',
      score_total: score,
      tier_code: tier.code,
      tier_label: tier.label,
      timestamp: new Date().toISOString()
    });
  }

  /* =============================================
     SHOW RESULTS
     ============================================= */
  /* OLD: Inline results display — replaced with redirect to dedicated results page
  function revealResults(score, tier) {
    sections.forEach(function (s) { s.style.display = 'none'; });
    emailGate.style.display = 'none';
    quizNav.style.display = 'none';
    document.querySelector('.quiz-progress').style.display = 'none';
    document.getElementById(tier.element).style.display = '';
    document.getElementById(tier.scoreDisplay).textContent = 'Your score: ' + score;
    quizResults.style.display = '';
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setTimeout(function () {
      if (typeof window.initSliderDots !== 'function') return;
      var tierBlock = document.getElementById(tier.element);
      if (!tierBlock) return;
      tierBlock.querySelectorAll('slider-component').forEach(function (sc) {
        if (sc.querySelector('.slider-counter--dots')) {
          window.initSliderDots(sc);
        }
      });
    }, 150);
  }
  */

  /* NEW: Redirect to dedicated results page instead of showing inline */
  function revealResults(score, tier) {
    window.location.href = '/pages/mold-quiz-result?score=' + score + '&tier=' + tier.code;
  }

  /* =============================================
     LOCALSTORAGE HELPERS
     ============================================= */
  function saveToLocal(email, score, tier, firstName, lastName) {
    try {
      localStorage.setItem('moldQuiz', JSON.stringify({
        first_name: firstName || '',
        last_name: lastName || '',
        email: email,
        score: score,
        tier_code: tier.code,
        tier_label: tier.label,
        tier_tag: tier.tag,
        timestamp: new Date().toISOString()
      }));
    } catch (e) { /* private browsing */ }
  }

  function clearLocal() {
    try { localStorage.removeItem('moldQuiz'); } catch (e) {}
  }

  function loadFromLocal() {
    try {
      var data = localStorage.getItem('moldQuiz');
      return data ? JSON.parse(data) : null;
    } catch (e) { return null; }
  }

  /* =============================================
     REHYDRATE (if page reloads after contact POST)
     ============================================= */
  /* OLD: tryRehydrate — causes auto-redirect to results page on quiz load.
     Results are now on a separate page so rehydration is no longer needed.
  function tryRehydrate() {
    var saved = loadFromLocal();
    if (saved && saved.tier_code) {
      var tier = getTier(saved.score);
      revealResults(saved.score, tier);
      return true;
    }
    return false;
  }
  */

  /* =============================================
     EVENT HANDLERS
     ============================================= */
  btnNext.addEventListener('click', function () {
    if (!validateSection(currentSection)) {
      validationMsg.style.display = '';
      return;
    }
    currentSection++;
    showSection(currentSection);
  });

  btnBack.addEventListener('click', function () {
    if (currentSection > 1) {
      currentSection--;
      showSection(currentSection);
    }
  });

  btnSeeResults.addEventListener('click', function () {
    if (!validateSection(currentSection)) {
      validationMsg.style.display = '';
      return;
    }
    // Hide quiz, show email gate
    sections.forEach(function (s) { s.style.display = 'none'; });
    quizNav.style.display = 'none';
    document.querySelector('.quiz-progress').style.display = 'none';
    emailGate.style.display = '';
    window.scrollTo({ top: 0, behavior: 'smooth' });

    /* Re-trigger Klaviyo form rendering (it was display:none on load) */
    if (window._klOnsite) {
      window._klOnsite.push(['openForm', 'SeyZJu']);
    }
  });

  /* =============================================
     KLAVIYO FORM — Detect submission and redirect
     ============================================= */
  (function watchKlaviyoForm() {
    var klaviyoContainer = document.querySelector('.klaviyo-form-SeyZJu');
    if (!klaviyoContainer) return;

    var redirected = false;

    function handleKlaviyoSubmit() {
      if (redirected) return;
      redirected = true;

      /* Try to extract name/email from Klaviyo form inputs */
      var firstName = '';
      var lastName = '';
      var email = '';

      /* Klaviyo forms use input fields — search inside the container */
      var allInputs = klaviyoContainer.querySelectorAll('input');
      allInputs.forEach(function (input) {
        var name = (input.name || '').toLowerCase();
        var type = (input.type || '').toLowerCase();
        var val = input.value || '';

        if (type === 'email' || name.indexOf('email') !== -1) {
          email = val.trim();
        } else if (name.indexOf('first') !== -1) {
          firstName = val.trim();
        } else if (name.indexOf('last') !== -1) {
          lastName = val.trim();
        }
      });

      /* Also try Klaviyo's iframe inputs if form is in iframe */
      if (!email) {
        var iframes = klaviyoContainer.querySelectorAll('iframe');
        iframes.forEach(function (iframe) {
          try {
            var iDoc = iframe.contentDocument || iframe.contentWindow.document;
            iDoc.querySelectorAll('input').forEach(function (input) {
              var name = (input.name || '').toLowerCase();
              var type = (input.type || '').toLowerCase();
              if (type === 'email' || name.indexOf('email') !== -1) email = input.value.trim();
              else if (name.indexOf('first') !== -1) firstName = input.value.trim();
              else if (name.indexOf('last') !== -1) lastName = input.value.trim();
            });
          } catch (e) { /* cross-origin iframe */ }
        });
      }

      // console.log('[Mold Quiz] Klaviyo form submitted:', { firstName: firstName, lastName: lastName, email: email });

      var score = calculateScore();
      var tier = getTier(score);

      /* Save to localStorage */
      saveToLocal(email, score, tier, firstName, lastName);

      /* Push to dataLayer */
      pushDataLayer(email, score, tier);

      /* Wait a moment for the user to see Klaviyo's success message, then redirect */
      setTimeout(function () {
        revealResults(score, tier);
      }, 2000);
    }

    /* Method 1: Listen for Klaviyo's custom event */
    window.addEventListener('klaviyoForms', function (e) {
      if (e.detail && (e.detail.type === 'submit' || e.detail.type === 'redirectedToUrl')) {
        handleKlaviyoSubmit();
      }
    });

    /* Method 2: MutationObserver — watch for Klaviyo success/thank-you state */
    var observer = new MutationObserver(function () {
      /* Klaviyo shows a success message after form submit — look for common patterns */
      var successEl = klaviyoContainer.querySelector('[data-testid="form-row"] .go3958317564') ||
                      klaviyoContainer.querySelector('.needsclick [data-testid="form-success"]') ||
                      klaviyoContainer.querySelector('form[data-success="true"]');

      /* Also check if the form inputs disappeared (replaced by thank-you) */
      var formVisible = klaviyoContainer.querySelector('form:not([style*="display: none"])');
      var hasInputs = klaviyoContainer.querySelector('input[type="email"]');
      var thankYouText = klaviyoContainer.querySelector('[class*="thank"], [class*="success"]');

      if (successEl || thankYouText || (formVisible === null && !hasInputs && klaviyoContainer.children.length > 0)) {
        handleKlaviyoSubmit();
      }
    });

    /* Start observing once the Klaviyo form container has content */
    var startObserver = setInterval(function () {
      if (klaviyoContainer.children.length > 0) {
        clearInterval(startObserver);
        observer.observe(klaviyoContainer, { childList: true, subtree: true, attributes: true, characterData: true });
      }
    }, 500);
  })();

  /* Close button — returns to quiz section 4 */
  var btnCloseGate = document.getElementById('btnCloseGate');
  if (btnCloseGate) {
    btnCloseGate.addEventListener('click', function () {
      emailGate.style.display = 'none';
      currentSection = 4;
      showSection(currentSection);
      quizNav.style.display = '';
      document.querySelector('.quiz-progress').style.display = '';
    });
  }

  btnRetake.addEventListener('click', function () {
    clearLocal();
    // Reset all inputs
    document.querySelectorAll('#mold-quiz input[type="radio"]').forEach(function (r) { r.checked = false; });
    document.querySelectorAll('#mold-quiz input[type="checkbox"]').forEach(function (c) { c.checked = false; });
    var fnField = document.getElementById('quizFirstName');
    var lnField = document.getElementById('quizLastName');
    if (fnField) fnField.value = '';
    if (lnField) lnField.value = '';

    // Reset state
    currentSection = 1;
    quizResults.style.display = 'none';
    document.getElementById('resultT1').style.display = 'none';
    document.getElementById('resultT2').style.display = 'none';
    document.getElementById('resultT3').style.display = 'none';
    quizNav.style.display = '';
    document.querySelector('.quiz-progress').style.display = '';
    showSection(1);
  });

  /* =============================================
     INIT
     ============================================= */
  setupQ11Exclusivity();

  /* OLD: Rehydrate causes auto-redirect — results now on separate page
  if (!tryRehydrate()) {
    showSection(1);
  }
  */

  /* NEW: Always show section 1 on quiz page load */
  showSection(1);
})();